import { LBtn } from "@components";
import { useUserPermission } from "@helpers/userPermissionHelper";
import { useModal } from "@services/ModalContext";
import { translate } from "react-i18nify";

export const ExistingFooter = ({ loading, onBeginAssessment }: ExistingFooterProps): JSX.Element => {
    const { onConfirm, formName } = useModal();
    const { isFacilitator } = useUserPermission({ useCurrentLocation: true });

    return (
        <div className="is-flex is-flex-direction-row is-justify-content-center">
            <LBtn variation="unstyled" onClick={onConfirm} isBold>
                {translate("admin.assessments.existing-assessment.savettoupcoming")}
            </LBtn>
            {isFacilitator && (
                <LBtn type="submit" form={formName} isBold loading={loading} onClick={onBeginAssessment}>
                    {translate("admin.assessments.existing-assessment.selectassessmentform")}
                </LBtn>
            )}
        </div>
    );
};

interface ExistingFooterProps {
    loading?: boolean;
    onBeginAssessment?: () => void;
}
